import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { FETCH_CANNED_RESPONSE_LIST, CREATE_CANNED_RESPONSE, UPDATE_CANNED_RESPONSE, DELETE_CANNED_RESPONSE } from "../actions/SMRCannedResponsesAction";

let initialState = {
    cannedResponseList: [],
    cannedResponseListLoading: false,
};

const cannedResponseReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending(FETCH_CANNED_RESPONSE_LIST):
            return (state = {
                ...state,
                cannedResponseListLoading: true,
                cannedResponseList: [],
            });
        case isRejected(FETCH_CANNED_RESPONSE_LIST):
            return (state = {
                ...state,
                cannedResponseListLoading: false,
                cannedResponseList: [],
            });
        case isFulfilled(FETCH_CANNED_RESPONSE_LIST): {
            return (state = {
                ...state,
                cannedResponseListLoading: false,
                cannedResponseList:
                    action.payload?.templates?.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    }) || [],
            });
        }

        case UPDATE_CANNED_RESPONSE:
            return (state = {
                ...state,
                cannedResponseListLoading: false,
                cannedResponseList:
                    action.payload.templates.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    }) || [],
            });

        default:
            return state;
    }
};
export default cannedResponseReducer;
